import React, { useState, useEffect } from 'react';
import { BackendURL } from '../utils/BackendURL';
import axios from 'axios';
import { Link } from "react-router-dom";
import { CustomerCareOptions } from '../Data/OptionsAndPaths';
import { ProfileInformation } from '../Data/ProfileInfo';
import weblogo from '../Images/logo.png';

export default function Footer() {

    return (
        <footer>
            <div className="footer-left">

                <div className="footer-imp-info">
                    <div className="footer-imp-logo">
                        <img src={weblogo} />
                    </div>
                    <div>
                        <span>Address:</span>
                        {ProfileInformation.address}
                    </div>
                    <div>
                        <span>PhoneNumber:</span>
                        {ProfileInformation.phoneNumber}
                    </div>
                    <div>
                        <span>Country:</span>
                        {ProfileInformation.country}
                    </div>
                </div>
                <div className="footer-contact-us">
                    <div className="footer-contact-us-title">
                        Follow Us
                    </div>
                    <div className="footer-contact-us-options">
                        <div className='footer-contact-us-option'>
                            <div className="circle-for-style">
                                <Link to={ProfileInformation.instagram} target="_blank">
                                    <i className="fab fa-instagram"></i>
                                </Link>
                            </div>
                        </div>
                        <div className='footer-contact-us-option'>
                            <div className="circle-for-style">
                                <Link to={ProfileInformation.facebook} target="_blank">
                                    <i className="fab fa-facebook"></i>
                                </Link>
                            </div>
                        </div>
                        <div className='footer-contact-us-option'>
                            <div className="circle-for-style">
                                <Link to={ProfileInformation.twitter} target="_blank">
                                    <i className="fab fa-twitter"></i>
                                </Link>
                            </div>
                        </div>
                        <div className='footer-contact-us-option'>
                            <div className="circle-for-style">
                                <Link to={ProfileInformation.email} target="_blank">
                                    <i className="fas fa-mail-bulk"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-right">
                <div className="parent-footer-customer-care">
                    <div className="footer-customer-care-title">
                        Customer Care
                    </div>
                    <div className="footer-customer-care">
                        {CustomerCareOptions.map((element, index) => (
                            <div key={index}>
                                <Link to={element.path}>
                                    {element.option}
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>


        </footer>
    );
}